var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinanceSmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.640137,
    y: 0.334217,
    width: 21,
    height: 21,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.65381,
    y: 6.78837,
    width: 9.12755,
    height: 3.4078,
    transform: "rotate(-45 4.65381 6.78837)",
    fill: "#F3BA2F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.146,
    y: 0.356318,
    width: 9.11489,
    height: 3.34246,
    transform: "rotate(45 11.146 0.356318)",
    fill: "#F3BA2F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6143,
    y: 14.8957,
    width: 9.12755,
    height: 3.4078,
    transform: "rotate(135 17.6143 14.8957)",
    fill: "#F3BA2F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1221,
    y: 21.3277,
    width: 9.11489,
    height: 3.34246,
    transform: "rotate(-135 11.1221 21.3277)",
    fill: "#F3BA2F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.74316,
    y: 10.8498,
    width: 3.38965,
    height: 3.40528,
    transform: "rotate(-45 8.74316 10.8498)",
    fill: "#F3BA2F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.650391,
    y: 10.8388,
    width: 3.38965,
    height: 3.40528,
    transform: "rotate(-45 0.650391 10.8388)",
    fill: "#F3BA2F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8354,
    y: 10.8554,
    width: 3.38965,
    height: 3.40528,
    transform: "rotate(-45 16.8354 10.8554)",
    fill: "#F3BA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceSmallIcon);
export default __webpack_public_path__ + "static/media/binanceSmallIcon.e6e8e9c47c1e109232aab60acb8566b4.svg";
export { ForwardRef as ReactComponent };